import EmailIcon from '@assets/social/email.svg';
import FacebookIcon from '@assets/social/facebook.svg';
import InstagramIcon from '@assets/social/instagram.svg';
import LinkedinIcon from '@assets/social/linkedin.svg';
import TiktokIcon from '@assets/social/tiktok.svg';
import WhatsappIcon from '@assets/social/whatsapp.svg';
import XIcon from '@assets/social/x.svg';
import YoutubeIcon from '@assets/social/youtube.svg';
import styles from './SocialIcon.module.scss';

export type SocialProvider =
  | 'email'
  | 'facebook'
  | 'instagram'
  | 'linkedin'
  | 'tiktok'
  | 'whatsapp'
  | 'x'
  | 'youtube';

export interface SocialIconProps {
  /** The social media provider to display */
  provider: SocialProvider;
  /** Additional CSS classes */
  className?: string;
  /** Alt text for accessibility (defaults to provider name) */
  alt?: string;
}

const providerIcons: Record<SocialProvider, string> = {
  email: EmailIcon,
  facebook: FacebookIcon,
  instagram: InstagramIcon,
  linkedin: LinkedinIcon,
  tiktok: TiktokIcon,
  whatsapp: WhatsappIcon,
  x: XIcon,
  youtube: YoutubeIcon,
};

const providerNames: Record<SocialProvider, string> = {
  email: 'Email',
  facebook: 'Facebook',
  instagram: 'Instagram',
  linkedin: 'LinkedIn',
  tiktok: 'TikTok',
  whatsapp: 'WhatsApp',
  x: 'X',
  youtube: 'YouTube',
};

export const SocialIcon = ({
  provider,
  className = '',
  alt,
}: SocialIconProps) => {
  const icon = providerIcons[provider];
  const defaultAlt = providerNames[provider];

  const containerClassName = [styles.container, className].filter(Boolean).join(' ');

  return (
    <div className={containerClassName}>
      <img
        src={icon}
        alt={alt ?? defaultAlt}
        className={styles.icon}
      />
    </div>
  );
};
